import { Search } from '@/DTOS/InterventionFile/Search';
import request from '../../utils/request';

const InterventionFileProjectService = {
  search: (search: Search) => {
    return request('/interventionFileProject/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      id: any;
      pmContractId: any;
      companyId: any;
      workPlaceId: any;
      attachedImage: any;
      observations: any;
      hours: any;
      minutes: any;
      traveledKilometers: any;
      timeTransportHours: any;
      timeTransportMinutes: any;
      deliveryDate: any;
      interventionFileProjectInstallations: any;
    }
  ) => {
    return request('/interventionFileProject/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          pmContractId: formData.pmContractId,
          companyId: formData.companyId,
          workPlaceId: formData.workPlaceId,
          attachedImage: formData.attachedImage,
          deliveryDate: formData.deliveryDate,
          observations: formData.observations,
          hours: formData.hours,
          minutes: formData.minutes,
          traveledKilometers: formData.traveledKilometers,
          timeTransportHours: formData.timeTransportHours,
          timeTransportMinutes: formData.timeTransportMinutes,
          interventionFileProjectInstallations: formData.interventionFileProjectInstallations,
        },
      }),
    });
  },

  getQuantityOfInstalledDevice: (search: Search) => {
    return request('/interventionFileProject/getQuantityOfInstalledDevice', {
      method: 'POST',
      body: JSON.stringify({
        request: { ...search },
      }),
    });
  },

  upload: (/** @type {any} */ file: any) => {
    return request(
      '/interventionFileProject/upload',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  delete: (/** @type {string} */ id: string) => {
    return request(`/interventionFileProject/delete/${id}`, {
      method: 'DELETE',
    });
  },
};

export default InterventionFileProjectService;
